export const reviewData = [
  {
    id: 1,
    quote:
      "Rapidiously develop user friendly growth strategies after extensive initiatives. Conveniently grow innovative benefits through fully tested deliverables. Rapidiously utilize focused platforms through end-to-end schemas",
    authImg: "assets/img/client-1.jpg",
    authName: "Arabella Orin",
    authTitle: "AppCo",
  },
  {
    id: 2,
    quote:
      "Rapidiously develop user friendly growth strategies after extensive initiatives. Conveniently grow innovative benefits through fully tested deliverables. Rapidiously utilize focused platforms through end-to-end schemas",
    authImg: "assets/img/client-2.jpg",
    authName: "Arabella Orin",
    authTitle: "AppCo",
  },
  {
    id: 3,
    quote:
      "Rapidiously develop user friendly growth strategies after extensive initiatives. Conveniently grow innovative benefits through fully tested deliverables. Rapidiously utilize focused platforms through end-to-end schemas",
    authImg: "assets/img/client-3.jpg",
    authName: "Arabella Orin",
    authTitle: "AppCo",
  },
  {
    id: 4,
    quote:
      "Rapidiously develop user friendly growth strategies after extensive initiatives. Conveniently grow innovative benefits through fully tested deliverables. Rapidiously utilize focused platforms through end-to-end schemas",
    authImg: "assets/img/client-4.jpg",
    authName: "Arabella Orin",
    authTitle: "AppCo",
  },
  {
    id: 5,
    quote:
      "Rapidiously develop user friendly growth strategies after extensive initiatives. Conveniently grow innovative benefits through fully tested deliverables. Rapidiously utilize focused platforms through end-to-end schemas",
    authImg: "assets/img/client-5.jpg",
    authName: "Arabella Orin",
    authTitle: "AppCo",
  },
  {
    id: 6,
    quote:
      "Rapidiously develop user friendly growth strategies after extensive initiatives. Conveniently grow innovative benefits through fully tested deliverables. Rapidiously utilize focused platforms through end-to-end schemas",
    authImg: "assets/img/client-2.jpg",
    authName: "Arabella Orin",
    authTitle: "AppCo",
  },
];

export const blogData = [
  {
    id: 1,
    category: "Lifstyle",
    thumbnail: "assets/img/blog/1.jpg",
    date: "Jan 21, 2019",
    comments: "45",
    share: "10",
    title: "Appropriately productize fully",
    excerpt:
      "Some quick example text to build on the card title and make up the bulk.",
  },
  {
    id: 2,
    category: "Technology",
    thumbnail: "assets/img/blog/2.jpg",
    date: "Jan 21, 2019",
    comments: "45",
    share: "10",
    title: "Quickly formulate backend",
    excerpt:
      "Synergistically engage effective ROI after customer directed partnerships",
  },
  {
    id: 3,
    category: "Science",
    thumbnail: "assets/img/blog/3.jpg",
    date: "April 26, 2019",
    comments: "41",
    share: "30",
    title: "Objectively extend extensive",
    excerpt:
      "Holisticly mesh open-source leadership rather than proactive users",
  },
  {
    id: 4,
    category: "Science",
    thumbnail: "assets/img/blog/4.jpg",
    date: "April 26, 2019",
    comments: "41",
    share: "30",
    title: "Objectively extend extensive",
    excerpt:
      "Holisticly mesh open-source leadership rather than proactive users",
  },
  {
    id: 5,
    category: "Science",
    thumbnail: "assets/img/blog/5.jpg",
    date: "April 26, 2019",
    comments: "41",
    share: "30",
    title: "Objectively extend extensive",
    excerpt:
      "Holisticly mesh open-source leadership rather than proactive users",
  },
  {
    id: 6,
    category: "Science",
    thumbnail: "assets/img/blog/6.jpg",
    date: "April 26, 2019",
    comments: "41",
    share: "30",
    title: "Objectively extend extensive",
    excerpt:
      "Holisticly mesh open-source leadership rather than proactive users",
  },
];
